// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"845":"ea50308d","936":"da2bde2d"}[chunkId] + ".chunk.js";
};